import { kebabCase } from "lodash";
import { camelize } from "humps";
import request from "@/utils/api/helpers";
import { camelizeObjectFieldNames } from "@/utils/dynamic/helpers";

const baseUrl = "/dynamic-object/schema";

export const getDynamicObjectByKey = (id) => request({
  url: `${baseUrl}/${id}`,
  method: "GET",
}).then((response) => {
  response.document = response.document.objects.map((field) => ({
    camelizedName: camelize(field.name),
    ...field
  }));

  return response;
});

export const getDynamicObjectByName = (objectName) => request({
  url: `${baseUrl}/by-name/${kebabCase(objectName)}`,
  method: "GET",
}).then((response) => {
  response.document = response.document.objects.map((field) => ({
    camelizedName: camelize(field.name),
    ...field
  }));

  return response;
});

export const getDynamicObjectByNameWithCamelizedFieldNames = (objectName) => request({
  url: `${baseUrl}/by-name/${kebabCase(objectName)}`,
  method: "GET",
}).then((response) => {
  response.layout = response.document.layout;
  response.actions = response.document.actions;
  response.document = camelizeObjectFieldNames(response.document.objects);
  return response;
});

export const getAllDynamicObjects = () => request({
  url: `${baseUrl}/all-names`,
  method: "GET",
});
